export default "__VITE_ASSET__AvJ2FstW__"